import { makeStyles } from '@material-ui/core/styles';

const useTourTooltipStyles = makeStyles((theme) => ({
  tooltip: {
    position: 'relative',
    maxWidth: '320px',
    padding: '18px 18px 16px',
    borderRadius: '16px',
    backgroundColor: theme.palette.white.main,
    boxShadow: '0 20px 45px rgba(23, 23, 24, 0.16)',
  },
  title: {
    margin: '0 0 8px',
    color: theme.palette.darkGray.main,
    fontFamily: 'Montserrat',
    fontSize: '17px',
    fontWeight: 700,
    lineHeight: '22px',
  },
  body: {
    margin: 0,
    color: theme.palette.gray.main,
    fontFamily: 'Montserrat',
    fontSize: '14px',
    lineHeight: '21px',
  },
  actions: {
    marginTop: '16px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '18px',
    flexWrap: 'wrap',
  },
  skipAction: {
    marginRight: 'auto',
  },
  secondaryAction: {
    color: `${theme.palette.gray.main} !important`,
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '16px',
    textTransform: 'uppercase',
  },
  primaryAction: {
    backgroundColor: `${theme.palette.primary.light} !important`,
    borderRadius: '8px',
    padding: '8px 12px',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '16px',
    color: theme.palette.grayScale9.main,
    textTransform: 'uppercase',
  },
  closeButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    color: `${theme.palette.gray.main} !important`,
    fontSize: '28px',
    lineHeight: 1,
  },
}));

export default useTourTooltipStyles;
